import React, { useEffect, useState } from 'react'
import Sells from '../Sells/Sells'
import axios from 'axios'
import Loading from '../../components/Display/Loading'
import { IFoodOrderById } from 'safe'

const server = process.env.REACT_APP_SERVER_URL

const CloseFoodOrder: React.FC = () => {

  const [render, setRender] = useState(false)

  const [foodOrder, setFoodOrder] = useState<IFoodOrderById | null>(null)

  const [isLoading, setIsLoading] = useState<boolean>(false)

  const [notFound, setNotFound] = useState<boolean>(false)

  const onGetComandaById = async () => {
    try {
      const id = new URLSearchParams(window.location.search).get('id')

    setIsLoading(true)

    const comanda = await axios.get<{order: IFoodOrderById}>(`${server}/food-order?id=${id}`)

    setFoodOrder(comanda.data?.order)

    setIsLoading(false)
    } catch (error: any) {
      if (error?.response?.data?.message === 'Order not found') {
        setNotFound(true)
      } 
      setIsLoading(false)
    }
  }

  useEffect(() => {
    onGetComandaById()

    setTimeout(() => {
      setRender(true)
    }, 1000)
  }, [])


  if (!render || isLoading) return <Loading />

  if (notFound) {
    return (
      <div className="flex flex-col items-center justify-center h-[70vh]">
        <h1 className="text-2xl font-bold">Comanda no encontrada</h1>
        <p className="text-sm text-gray-500">La comanda que estás buscando no existe.</p>
      </div>
    )
  }

  if (foodOrder && foodOrder?.items?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-[70vh]">
        <h1 className="text-2xl font-bold">Comanda sin articulos</h1>
        <p className="text-sm text-gray-500">La comanda que estás buscando no tiene articulos.</p>
      </div>
    )
  }
  
  return (
    <Sells
      setHeaderActions={() => {}}
      clientProp={null}
      itemsProp={foodOrder?.items?.map(x => ({
        amount: x.quantity.toString(),

        barcode: x.barcode,
        brand: x.brand,
        category: {
          id: x?.categoryId?.toString() || '',
          name: x?.categoryName || '',
        },
        cost: x?.cost?.toString() || '',
        currency: {
          id: x?.currency?.id.toString() || '',
        },
        description: x.description,
        id: x?.idItem?.toString() || '',
        inCatalog: x.inCatalog,
        ivaType: x.ivaType,
        name: x.name,
        price: x?.price?.toString() || '',
        quantity: x?.quantity?.toString() || '',
        sku: x.sku,
        type: x.itemType,
        unit: {
          id: x?.unitId?.toString() || '',
        },
       
      }))}
      payment_methods={[]}
      statusProp="FOOD_ORDER"
      onGoBack={() => {}}
    />
  )
}

export default CloseFoodOrder